module.exports = __webpack_public_path__ + "static/img/qrcode.e923afd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/qrcode.png
// module id = MSXS
// module chunks = 0